import { IsNullOrEmpty } from "./NullEmptyHelpers";
import objectHash from "object-hash";
import LZString from "lz-string";

function GetObjectPropertyValue(input, propertyName, valueIfNotFound = "") {
  if (IsNullOrEmpty(input)) {
    return valueIfNotFound;
  }

  if (IsNullOrEmpty(propertyName)) {
    return valueIfNotFound;
  }

  if (typeof input !== "object") {
    return valueIfNotFound;
  }

  // if the object has the property, return the value, make sure the property is case insensitive
  let keys = Object.keys(input);
  let key = keys.find((k) => k.toLowerCase() === propertyName.toLowerCase());
  if (key) {
    return input[key];
  }

  return valueIfNotFound;
}

function GetObjectHashValue(input) {
  if (IsNullOrEmpty(input)) {
    return "";
  }

  try {
    return objectHash(input);
  } catch (error) {
    // in case of error, return empty string

    // log the error
    console.error("Error in GetObjectHashValue: ", error);
    return "";
  }
}

//adding comnpression and decompression functions for URI strings
// these functions use LZString library to compress and decompress strings
//This was after encounteri9ng issues with long query strings in URLs
// on the AAPI level, use CompressionHelpers to decompress the strings
function CompressUriString(input) {
  const compressed = LZString.compressToEncodedURIComponent(input);

  return compressed;
}

function DeCompressUriString(compressedInput) {
  // Decompress
  const uncompressed =
    LZString.decompressFromEncodedURIComponent(compressedInput);

  return uncompressed;
}

export {
  GetObjectPropertyValue,
  GetObjectHashValue,
  CompressUriString,
  DeCompressUriString,
};
